import { useCreateFieldGetter, useFieldBorder } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for SelfService link item customisation
 * Returns self-service link configuration and styling for a specific link section
 * @param sectionKey - The section key for the specific link (e.g., HELP_SECTION_KEYS.SELF_SERVICE_LINK_1)
 */
export const useSelfServiceLinkCustomisation = (sectionKey: string) => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HELP_PAGE,
    sectionKey,
    blockKey: PUI.HELP_BLOCK_KEYS.BODY_SECTION,
  });

  const labelColor = getField(PUI.COMMON_FIELD_KEYS.LABEL_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const articleId = getField(PUI.COMMON_FIELD_KEYS.ARTICLE_ID);
  const { borderColor } = useFieldBorder();

  return {
    isVisible,
    labelColor,
    backgroundColor,
    articleId,
    borderColor,
  };
};
